import NotFund from "../views/error/NotFund";
import Admin from "../views/admin/Index";

//需要登录
const requireLoginMeta = { requireLogin: true };

//需要访问权限
const requireAuthMeta = { requireAuth: true };

//路由表
const routes = [
	{
		path: "/",
		name: "Login",
		component: () => import(/* webpackChunkName: "login" */ "../views/login/Login.vue"),
	},
	{
		path: "/login",
		name: "Login",
		component: () => import(/* webpackChunkName: "login" */ "../views/login/Login.vue"),
	},
	{
		path: "/admin",
		name: "admin",
		component: Admin,
		meta: { ...requireLoginMeta, ...requireAuthMeta },
		children: [
			{
				path: "home",
				name: "Home",
				meta: { ...requireLoginMeta, ...requireAuthMeta },
				component: () => import(/* webpackChunkName: "home" */ "../views/admin/Home.vue"),
			},
			{
				path: "user",
				name: "user",
				meta: { ...requireLoginMeta, ...requireAuthMeta },
				component: () => import(/* webpackChunkName: "mini_permission" */ "../views/user/Index.vue"),
			},
			{
				path: "resources",
				name: "resources",
				meta: { ...requireLoginMeta, ...requireAuthMeta },
				component: () => import(/* webpackChunkName: "resouces" */ "../views/resources/Index.vue"),
			},
			{
				path: "menu",
				name: "menu",
				meta: { ...requireLoginMeta, ...requireAuthMeta },
				component: () => import(/* webpackChunkName: "menu" */ "../views/menu/Index.vue"),
			},
			{
				path: "permission",
				name: "permission",
				meta: { ...requireLoginMeta, ...requireAuthMeta },
				component: () => import(/* webpackChunkName: "permission" */ "../views/permission/Index.vue"),
			},
			{
				path: "mini_permission",
				name: "mini_permission",
				meta: { ...requireLoginMeta, ...requireAuthMeta },
				component: () => import(/* webpackChunkName: "mini_permission" */ "../views/permission/MiniIndex.vue"),
			},


			{
				path: "logs",
				name: "logs",
				meta: { ...requireLoginMeta, ...requireAuthMeta },
				component: () => import("../views/logs/Index.vue"),
			},
			{
				path: "corp_achievement",
				name: "corp_achievement",
				meta: { ...requireLoginMeta, ...requireAuthMeta },
				component: () => import("../views/corpAchievement/Index.vue"),
			},
			{
				path: "depart_achievement",
				name: "depart_achievement",
				meta: { ...requireLoginMeta, ...requireAuthMeta },
				component: () => import("../views/departAchievement/Index.vue"),
			},
			{
				path: "group_achievement",
				name: "group_achievement",
				meta: { ...requireLoginMeta, ...requireAuthMeta },
				component: () => import("../views/groupAchievement/Index.vue"),
			},
			// app 员工业绩
			{
				path: "user_achievement",
				name: "user_achievement",
				//meta: { ...requireLoginMeta, ...requireAuthMeta },
				meta: { ...requireLoginMeta, ...requireAuthMeta },
				component: () => import("../views/userAchievement/Index.vue"),
			},

			// app 用户列表 
			{
				path: "app_user",
				name: "app_user",
				//meta: { ...requireLoginMeta, ...requireAuthMeta },
				meta: { ...requireLoginMeta, ...requireAuthMeta },
				component: () => import("../views/appUser/Index.vue"),
			},

			// app 用户充值列表	
			{
				path: "app_user_recharge",
				name: "app_user_recharge",
				//meta: { ...requireLoginMeta, ...requireAuthMeta },
				meta: { ...requireLoginMeta, ...requireAuthMeta },
				component: () => import("../views/appUserRecharge/Index.vue"),
			},
			// app 用户消费列表	
			{
				path: "app_user_consume",
				name: "app_user_consume",
				//meta: { ...requireLoginMeta, ...requireAuthMeta },
				meta: { ...requireLoginMeta, ...requireAuthMeta },
				component: () => import("../views/appUserConsume/Index.vue"),
			},
			// app 用户 公会代充列表	
			{
				path: "app_user_sociaty",
				name: "app_user_sociaty",
				//meta: { ...requireLoginMeta, ...requireAuthMeta },
				meta: { ...requireLoginMeta, ...requireAuthMeta },
				component: () => import("../views/appUserSociaty/Index.vue"),
			},
			// app 用户 后台充值列表	
			{
				path: "app_user_admin",
				name: "app_user_admin",
				//meta: { ...requireLoginMeta, ...requireAuthMeta },
				meta: { ...requireLoginMeta, ...requireAuthMeta },
				component: () => import("../views/appUserAdmin/Index.vue"),
			},
			// app 用户 补录审核
			{
				path: "app_user_additional",
				name: "app_user_additional",
				//meta: { ...requireLoginMeta, ...requireAuthMeta },
				meta: { ...requireLoginMeta, ...requireAuthMeta },
				component: () => import("../views/appUserAdditional/Index.vue"),
			},

			// 员工职位管理
			{
				path: "position",
				name: "position",
				//meta: { ...requireLoginMeta, ...requireAuthMeta },
				meta: { ...requireLoginMeta, ...requireAuthMeta },
				component: () => import("../views/userPosition/Index.vue"),
			},

			{
				path: "app_user_double",
				name: "app_user_double",
				//meta: { ...requireLoginMeta, ...requireAuthMeta },
				meta: { ...requireLoginMeta, ...requireAuthMeta },
				component: () => import("../views/appUserDouble/Index.vue"),
			},

			{
				path: "lottery",
				name: "lottery",
				//meta: { ...requireLoginMeta, ...requireAuthMeta },
				meta: { ...requireLoginMeta, ...requireAuthMeta },
				component: () => import("../views/appUserLottery/Index.vue"),
			},

		],
	},
	{
		path: "*",
		name: "NotFund",
		component: NotFund,
	},
];

export default routes;
